import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";

// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
// CopyrightRegistration.jsx
import { Helmet } from "react-helmet";

const CopyrightRegistration = () => {

   const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="service-page">
 
      <Helmet>
        <title>
          Copyright Registration Service in India | Protect Creative Work
        </title>

        <meta
          name="description"
          content="Protect your original content, software, music, videos, books, designs, and creative work with Copyright Registration in India."
        />

        <meta
          name="keywords"
          content="Copyright Registration, Copyright India, Software Copyright, Content Protection, Music Copyright, Website Content Copyright"
        />
      </Helmet> 

      {/* HERO */}
      <section className="service-hero">
        <h1>Copyright Registration Service (©)</h1>
        <p>
          Protect Your Creative Work, Content & Intellectual Property Legally
        </p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="card">
          <p>
            Copyright Registration protects original creative work from
            unauthorized copying, reproduction, or misuse. It gives the creator
            legal ownership rights over their intellectual creations.
          </p>

          <p>
            Registered copyright helps creators, businesses, developers, and
            artists secure their work legally and establish proof of ownership.
          </p>
        </div>
      </section>

      {/* WHAT IT PROTECTS */}
      <section className="service-section">
        <h2>What Does Copyright Protect?</h2>

        <div className="service-grid-box">

          <div className="card">
            Website Content & Articles
          </div>

          <div className="card">
            Photos & Graphic Designs
          </div>

          <div className="card">
            Videos & Films
          </div>

          <div className="card">
            Software Source Code
          </div>

          <div className="card">
            Music & Audio Content
          </div>

          <div className="card">
            Books, PDFs & E-books
          </div>

        </div>
      </section>

      {/* EXAMPLES */}
      <section className="service-section">
        <h2>Examples of Copyrightable Work</h2>

        <div className="card">
          <ul>
            <li>Website content and blogs</li>
            <li>Software applications & code</li>
            <li>Videos, reels & YouTube content</li>
            <li>Music compositions & recordings</li>
            <li>Books, magazines & e-books</li>
            <li>Creative artwork & illustrations</li>
          </ul>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Copyright Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            ✔ Legal ownership proof
          </div>

          <div className="card">
            ✔ Protection against copying
          </div>

          <div className="card">
            ✔ Exclusive usage rights
          </div>

          <div className="card">
            ✔ Helps in legal disputes
          </div>

          <div className="card">
            ✔ Enhances business value
          </div>

          <div className="card">
            ✔ Protects digital & creative assets
          </div>

        </div>
      </section>

      {/* VALIDITY */}
      <section className="service-section">
        <h2>Copyright Validity</h2>

        <div className="card">
          <p>
            Copyright protection generally remains valid for the{" "}
            <strong>lifetime of the creator plus 60 years</strong> after death,
            as per Indian Copyright Law.
          </p>
        </div>
      </section>

      {/* WHO SHOULD APPLY */}
      <section className="service-section">
        <h2>Who Should Apply for Copyright?</h2>

        <div className="service-grid-box">

          <div className="card">
            Content Creators
          </div>

          <div className="card">
            Software Developers
          </div>

          <div className="card">
            Designers & Artists
          </div>

          <div className="card">
            Authors & Writers
          </div>

          <div className="card">
            Musicians & Filmmakers
          </div>

          <div className="card">
            Agencies & Startups
          </div>

        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">

          <div className="card">
            PAN Card
          </div>

          <div className="card">
            Aadhaar Card
          </div>

          <div className="card">
            Copy of Original Work
          </div>

          <div className="card">
            Author Details
          </div>

          <div className="card">
            Business Registration (if applicable)
          </div>

          <div className="card">
            NOC (if required)
          </div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Copyright Registration Process</h2>

        <div className="service-grid-box">

          <div className="card">
            Application Preparation
          </div>

          <div className="card">
            Submission of Creative Work
          </div>

          <div className="card">
            Government Filing
          </div>

          <div className="card">
            Diary Number Generation
          </div>

          <div className="card">
            Examination & Verification
          </div>

          <div className="card">
            Copyright Certificate Issuance
          </div>

        </div>
      </section>

      {/* OUR SERVICES */}
      <section className="service-section">
        <h2>Our Copyright Services Include</h2>

        <div className="card">
          <ul>
            <li>Copyright consultation & eligibility check</li>
            <li>Application drafting & filing</li>
            <li>Documentation support</li>
            <li>Software & content copyright filing</li>
            <li>Copyright objection assistance</li>
            <li>Complete end-to-end support</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card">
          <ul>
            <li>✔ Experienced IPR professionals</li>
            <li>✔ Fast & hassle-free process</li>
            <li>✔ Affordable pricing</li>
            <li>✔ Secure document handling</li>
            <li>✔ Dedicated support team</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Protect Your Creative Work Today</h2>

        <p>
          Secure your original content, software, music, and creative assets
          with professional copyright registration services.
        </p>

        <button>Apply for Copyright</button>
      </section> */}
      
         <div className="cta" ref={contactRef}>
              <h2>Protect Your Creative Work Today</h2>
              <p>Secure your original content, software, music, and creative assets
          with professional copyright registration services.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Apply for Copyright</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>



    </div>
  );
};

export default CopyrightRegistration;